import React from 'react'
import classNames from 'classnames'
import { BasicTestimonialCardProps } from './types.d'

const BasicTestimonialCard = ({
  icon,
  sectionHeading,
  displayName,
  ctaLabel,
  restaurantName,
  classes
}: BasicTestimonialCardProps) => {
  const basicTestimonialCardClasses = classNames(
    classes,
    'grid-rows-[min-content]'
  )

  const renderName = () => {
    if (displayName || ctaLabel || restaurantName) {
      return (
        <div>
          {displayName ? (
            <p className='text-default font-semibold'>{displayName}</p>
          ) : null}
          {ctaLabel ? <span className='text-secondary'>{ctaLabel}</span> : null}
          {ctaLabel && restaurantName ? (
            <span>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
          ) : null}
          {restaurantName ? (
            <span className='text-secondary'>{restaurantName}</span>
          ) : null}
        </div>
      )
    }
  }

  return (
    <div
      className={basicTestimonialCardClasses}
      data-testid='mds-basic-testimonial-card'
    >
      <div>
        {icon[0] ? (
          <img
            alt='Testimonial Quote Icon'
            className='mb-2 md:mb-4 w-[40px] h-[40px]'
            src={icon[0].url}
          />
        ) : null}
        {sectionHeading ? (
          <p className='font-effra test-[1.25rem] leading-[1.75rem] text-default font-normal mb-2 md:mb-4'>
            {sectionHeading}
          </p>
        ) : null}
        {renderName()}
      </div>
    </div>
  )
}

export default BasicTestimonialCard
